import src from "IMAGE";
export default { src, width: 1155, height: 240, blurWidth: 0, blurHeight: 0};
